import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';

function FormErrors({
  errors,
  component: ErrorComponent = Alert,
  variant = 'danger',
  showErrors = true
}) {
  if (!showErrors) {
    return null;
  }
  return (
    <div className="form-errors">
      {errors.map((error, index) => (
        <ErrorComponent key={index} role="alert" variant={variant}>
          {error}
        </ErrorComponent>
      ))}
    </div>
  );
}

FormErrors.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ).isRequired,
  component: PropTypes.element,
  variant: PropTypes.string,
  showErrors: PropTypes.bool
};

export default FormErrors;
